import { useEffect, useState } from 'react'

/**
 * Valor atrasado.
 *
 * A caixa de busca escreve no estado a cada tecla — o campo precisa responder
 * na hora — mas a requisição só sai quando a digitação para. Sem isso, "acme"
 * dispara quatro listagens, e a resposta da segunda pode chegar depois da
 * quarta e repintar a tabela com o resultado errado.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [delayed, setDelayed] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDelayed(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return delayed
}
